import * as React from 'react';
/**
 * @ignore - internal component.
 */

var FormControlContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

export function useFormControl() {
  return React.useContext(FormControlContext);
}
export default FormControlContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormControl/FormControlContext.js
// module id = 244
// module chunks = 0